/**
 * As três verificações (pendência, cancelada, bloqueio) começam com null e viram true/false ao
 * terminar. Basta uma achar algo para o card ocupar o lugar da faixa de carregamento.
 */
export function verificandoCartaoSim(personId: number, ...resultados: (boolean | null)[]): boolean {
  if (!personId || resultados.some(r => r === true)) return false;
  return resultados.some(r => r === null);
}
